// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"ben_a bhi_bk bhi_bl bhi_bo","SwipeLeftToClose--animating":"ben_b"};